import React from 'react';
import { Factory, Wrench } from 'lucide-react';

export default function LineFilter({ lines, selectedLines, onToggle }) {
  const lineItems = lines.filter(l => l.line_type !== 'table');
  const tableItems = lines.filter(l => l.line_type === 'table');

  return (
    <div className="flex items-center gap-3" data-testid="line-filter">
      {/* Lines */}
      {lineItems.length > 0 && (
        <div className="flex items-center gap-1.5">
          <Factory className="w-3.5 h-3.5 text-slate-400 mr-0.5" />
          {lineItems.map(l => {
            const active = selectedLines.includes(l.id);
            return (
              <button key={l.id} onClick={() => onToggle(l.id)}
                className={`px-3 py-1.5 text-xs font-semibold rounded-lg border transition-all ${active
                  ? 'bg-slate-800 text-white border-slate-800'
                  : 'bg-white text-slate-500 border-slate-200 hover:border-slate-400'}`}
                data-testid={`line-filter-${l.code}`}>
                {l.code}
              </button>
            );
          })}
        </div>
      )}

      {/* Separator */}
      {lineItems.length > 0 && tableItems.length > 0 && (
        <div className="w-px h-6 bg-slate-200" />
      )}

      {/* Tables */}
      {tableItems.length > 0 && (
        <div className="flex items-center gap-1.5">
          <Wrench className="w-3.5 h-3.5 text-amber-500 mr-0.5" />
          {tableItems.map(l => {
            const active = selectedLines.includes(l.id);
            return (
              <button key={l.id} onClick={() => onToggle(l.id)}
                className={`px-3 py-1.5 text-xs font-semibold rounded-lg border transition-all ${active
                  ? 'bg-amber-600 text-white border-amber-600'
                  : 'bg-amber-50 text-amber-700 border-amber-200 hover:border-amber-400'}`}
                data-testid={`line-filter-${l.code}`}>
                {l.code}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
